"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lib_1 = require("../../lib");
const RadioButton = ({ option, checked, onChange, className, labelClassName, value, }) => {
    const handleOnChange = (0, react_1.useCallback)(() => {
        if (onChange)
            onChange(option.value);
    }, [option.value, onChange]);
    const isChecked = checked || value == option.value;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)("style-guide-radio-button", className), onClick: handleOnChange }, { children: [(0, jsx_runtime_1.jsx)("div", { className: (0, lib_1.classnames)((0, lib_1.bem)("style-guide-radio-button__button", (0, lib_1.use)(isChecked, "--checked"))) }, void 0), (0, jsx_runtime_1.jsx)("label", Object.assign({ className: (0, lib_1.classnames)("style-guide-radio-button__label", labelClassName) }, { children: option.label }), void 0)] }), void 0));
};
exports.RadioButton = RadioButton;
//# sourceMappingURL=RadioButton.js.map